import React from "react";

export default class Flight extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      active: false
    };
  }



  render() {
    const months = (",Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec").split(',');
    const ll = this.props;
    return (
      <div className="launch-details">
        <div className="row">
          <div className="col-4 launcher">
            <span className="label">Launcher</span>
            <span className="val">{ll.launcher}</span>
          </div>
          <div className="date col-4">
            <span className="label">Date of launch</span>
            <span className="val">{months[parseInt(ll.launch_date_m)]} {ll.launch_date_y}</span>
          </div>

          <div className="vehicle col-4">
            <span className="label">Vehicle</span>
            <span className="val">{ll.vehicle}</span>
          </div>
        </div>
        <div className="hr"></div>
        <div className="row">
          <div className="date col-3">
            <span className="label">Destination</span>
            <span className="val">{ll.destination}</span>
          </div>
          <div className="sat col-3">
            <span className="label">Inclination</span>
            <span className="val">{ll.incl}</span>
          </div>
          <div className="vehicle col-3">
            <span className="label">Altitude</span>
            <span className="val">{ll.alt}</span>
          </div>
          <div className="vehicle col-3">
            <span className="label">LTDN/LTAN</span>
            <span className="val">{ll.ll}</span>
          </div>
        </div>
      </div>
    );
  }

}
